/**
 * next/link → TanStack Router Link. `href` maps to `to`; Next-only props
 * (prefetch/scroll/shallow) are dropped — TSR Link already preloads on intent.
 */
import { Link as TanStackLink } from "@tanstack/react-router"
import { forwardRef, type ComponentProps } from "react"

type Props = Omit<ComponentProps<typeof TanStackLink>, "to"> & {
  href: string
  prefetch?: boolean | null
  scroll?: boolean
  shallow?: boolean
}

const Link = forwardRef<HTMLAnchorElement, Props>(function Link(
  { href, prefetch: _p, scroll: _s, shallow: _sh, ...rest },
  ref,
) {
  return <TanStackLink to={href as never} {...rest} ref={ref} />
})

export default Link
